// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.combo-box__search-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
}
.combo-box__search-input-icon {
  color: var(--color-icon-base);
}
.combo-box__search-input-input {
  border: none;
  outline: none;
  width: 100%;
}
.combo-box__item-group {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.combo-box__group-heading {
  /* 10px on the right to save the scroll from covering the outline of trailing elements with focus state */
  padding: 6px 10px 6px 8px;
}
.combo-box__heading-text {
  color: var(--color-content-secondary);
}
.combo-box__item-group .combo-box__item ~ .combo-box__item {
  margin-top: 4px;
}
.combo-box__item {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 1 0 0;
  padding: 6px 8px;
  margin: 0 8px;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
  border-radius: 8px;
  color: var(--color-content-base);
  background-color: var(--color-popover-background);
  /**
   * This rule applies to items with both 'destructive' and 'active' classes. However, in practice, a destructive item
   * shouldn't be active. Destructive actions are performed once and aren't meant to be toggled on/off like a checkbox
   * or radio.
   *
   * The purpose of this selector is to reset the style back to the default in case this two modifiers are applied at
   * the same time by mistake.
   */
  font-size: 14px;
  padding: 6px 16px;
  margin: 0;
}
.combo-box__item:last-of-type {
  margin-bottom: 0;
}
:where(.combo-box__item) .v-icon {
  color: var(--color-icon-base);
}
.combo-box__item[data-highlighted] {
  background-color: var(--color-popover-background-hover);
}
.combo-box__item[data-disabled] {
  opacity: 0.5;
  pointer-events: none;
}
.combo-box__item--check[data-state='checked'],
.combo-box__item--active {
  font-weight: 600;
  color: var(--color-accent-content-contrast);
  background-color: var(--color-accent-subtle-background-subdued);
}
.combo-box__item--check[data-state='checked'] .v-icon,
.combo-box__item--active .v-icon {
  color: var(--color-accent-content-base);
  background-color: transparent;
}
.combo-box__item--check[data-state='checked'][data-highlighted],
.combo-box__item--active[data-highlighted] {
  background-color: var(--color-accent-subtle-background-hover);
}
.combo-box__item--destructive {
  color: var(--color-error-content-base);
}
.combo-box__item--destructive .v-icon {
  color: var(--color-error-content-base);
}
.combo-box__item--destructive.combo-box__item--active.combo-box__item:not([data-highlighted]) {
  background: var(--color-accent-subtle-background-hover);
  font-weight: 400;
}
.combo-box__header {
  padding: 4px 8px;
  width: 100%;
}
.combo-box__separator {
  height: 1px;
  background-color: var(--color-border-base);
  margin: 4px 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/combo-box/ComboBox.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/menu.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/separator.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAQJ;AALE;EACE,6BAAA;AAOJ;AAJE;EACE,YAAA;EACA,aAAA;EAEA,WAAA;AAKJ;AAFE;EACE,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;AAGJ;AAAE;EAEA,yGAAyG;EAAvG,yBAAA;AAEJ;AACE;EACE,qCAAA;AACJ;AAGE;EACE,eAAA;AADJ;AAIE;ECpCA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EAEA,gBAAA;EACA,aAAA;EAEA,yBAAA;UAAA,iBAAA;EACA,aAAA;EAEA,kBAAA;EACA,gCAAA;EACA,iDAAA;ED+BA;;;;;;;IAOE;EAhBA,eAAA;EAEA,iBAAA;EACA,SAAA;AAiBJ;ACxCE;EACE,gBAAA;AD0CJ;ACvCE;EACE,6BAAA;ADyCJ;ACtCE;EACE,uDAAA;ADwCJ;ACrCE;EACE,YAAA;EACA,oBAAA;ADuCJ;ACpCE;;EAEE,gBAAA;EACA,2CAAA;EACA,+DAAA;ADsCJ;ACnCE;;EAEE,uCAAA;EACA,6BAAA;ADqCJ;AClCE;;EAEE,6DAAA;ADoCJ;ACjCE;EACE,sCAAA;ADmCJ;AChCE;EACE,sCAAA;ADkCJ;ACvBE;EACE,uDAAA;EACA,gBAAA;ADyBJ;AApDE;EACE,gBAAA;EACA,WAAA;AAsDJ;AAnDE;EErDA,WAAA;EACA,0CAAA;EACA,aAAA;AF2GF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.combo-box {\n  &__search-input-wrapper {\n    display: flex;\n    align-items: center;\n    gap: @layoutUnit-sm;\n    padding: @layoutUnit-xs;\n  }\n\n  &__search-input-icon {\n    color: var(--color-icon-base);\n  }\n\n  &__search-input-input {\n    border: none;\n    outline: none;\n\n    width: 100%;\n  }\n\n  &__item-group {\n    overflow: hidden;\n\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__group-heading {\n    /* 10px on the right to save the scroll from covering the outline of trailing elements with focus state */\n    padding: 6px 10px 6px 8px;\n  }\n\n  &__heading-text {\n    color: var(--color-content-secondary);\n  }\n\n\n  &__item-group &__item ~ &__item {\n    margin-top: 4px;\n  }\n\n  &__item {\n    .menu-item-styles();\n    font-size: @fontSize-sm;\n\n    padding: 6px @layoutUnit-md;\n    margin: 0;\n  }\n\n  &__header {\n    padding: @layoutUnit-xs @layoutUnit-sm;\n    width: 100%;\n  }\n\n  &__separator {\n    .separator();\n  }\n}\n","@import '~venus';\n\n.menu-content-styles() {\n  .popover-content-styles();\n}\n\n.menu-item-styles() {\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: @layoutUnit-sm;\n  flex: 1 0 0;\n\n  padding: 6px 8px;\n  margin: 0 @layoutUnit-sm;\n\n  user-select: none;\n  outline: none;\n\n  border-radius: @layoutUnit-sm;\n  color: var(--color-content-base);\n  background-color: var(--color-popover-background);\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n\n  :where(&) .v-icon {\n    color: var(--color-icon-base);\n  }\n\n  &[data-highlighted] {\n    background-color: var(--color-popover-background-hover);\n  }\n\n  &[data-disabled] {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &--check[data-state='checked'],\n  &--active {\n    font-weight: 600;\n    color: var(--color-accent-content-contrast);\n    background-color: var(--color-accent-subtle-background-subdued);\n  }\n\n  &--check[data-state='checked'] .v-icon,\n  &--active .v-icon {\n    color: var(--color-accent-content-base);\n    background-color: transparent;\n  }\n\n  &--check[data-state='checked'][data-highlighted],\n  &--active[data-highlighted] {\n    background-color: var(--color-accent-subtle-background-hover);\n  }\n\n  &--destructive {\n    color: var(--color-error-content-base);\n  }\n\n  &--destructive .v-icon {\n    color: var(--color-error-content-base);\n  }\n\n  /**\n   * This rule applies to items with both 'destructive' and 'active' classes. However, in practice, a destructive item\n   * shouldn't be active. Destructive actions are performed once and aren't meant to be toggled on/off like a checkbox\n   * or radio.\n   *\n   * The purpose of this selector is to reset the style back to the default in case this two modifiers are applied at\n   * the same time by mistake.\n   */\n  &--destructive&--active&:not([data-highlighted]) {\n    background: var(--color-accent-subtle-background-hover);\n    font-weight: 400;\n  }\n}\n","@import \"./../variables.less\";\n\n.separator() {\n  height: 1px;\n  background-color: var(--color-border-base);\n  margin: @layoutUnit-xs 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
